<button type="button" class="btn-dt-save-blue" [disabled]="!allowed_to_update">
  <div class="icon-position">
    <img src="/assets/icons/save-icon-blue.svg">&nbsp;&nbsp;
  </div>
  <span>{{label}}</span>
</button>
